<div class="overlay" *ngIf="isLoading" [ngStyle]="{top:topOffset}">
    <div class="center">
        <i class="fas fa-spinner fa-spin me-1"></i>
        <span>Loading...</span>
    </div>
</div>